"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function ApiCallExternal(_x, _x2, _x3, _x4) {
  return _ApiCallExternal.apply(this, arguments);
}

function _ApiCallExternal() {
  _ApiCallExternal = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, type, data, header) {
    var response, _response, _response2, _response3;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(type === "get" || !type)) {
              _context.next = 14;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return _axios["default"].get(url);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            return _context.abrupt("return", {
              error: true,
              errorStatus: _context.t0.response.status,
              errorMessage: _context.t0.response.data
            });

          case 12:
            _context.next = 51;
            break;

          case 14:
            if (!(type === "post")) {
              _context.next = 27;
              break;
            }

            _context.prev = 15;
            _context.next = 18;
            return _axios["default"].post(url, data);

          case 18:
            _response = _context.sent;
            return _context.abrupt("return", _response);

          case 22:
            _context.prev = 22;
            _context.t1 = _context["catch"](15);
            return _context.abrupt("return", {
              error: true,
              errorStatus: _context.t1.response.status,
              errorMessage: _context.t1.response.data
            });

          case 25:
            _context.next = 51;
            break;

          case 27:
            if (!(type === "put")) {
              _context.next = 40;
              break;
            }

            _context.prev = 28;
            _context.next = 31;
            return _axios["default"].put(url, data);

          case 31:
            _response2 = _context.sent;
            return _context.abrupt("return", _response2);

          case 35:
            _context.prev = 35;
            _context.t2 = _context["catch"](28);
            return _context.abrupt("return", {
              error: true,
              errorStatus: _context.t2.response.status,
              errorMessage: _context.t2.response.data
            });

          case 38:
            _context.next = 51;
            break;

          case 40:
            if (!(type === "delete")) {
              _context.next = 51;
              break;
            }

            _context.prev = 41;
            _context.next = 44;
            return _axios["default"]["delete"](url);

          case 44:
            _response3 = _context.sent;
            return _context.abrupt("return", _response3);

          case 48:
            _context.prev = 48;
            _context.t3 = _context["catch"](41);
            return _context.abrupt("return", {
              error: true,
              errorStatus: _context.t3.response.status,
              errorMessage: _context.t3.response.data
            });

          case 51:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8], [15, 22], [28, 35], [41, 48]]);
  }));
  return _ApiCallExternal.apply(this, arguments);
}

var _default = ApiCallExternal;
exports["default"] = _default;